import { icons } from 'assets';
import ActionCard from 'Components/shared/cards/ActionCard';
import WalletCard, { CurrencyCard } from 'Components/shared/cards/WalletCard';
import React, { startTransition } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useGetWalletBalance } from 'services/walletService';
import { convertToCurrency } from 'utils/stringServices';

import styles from '../wallet.module.css';

const Banner = ({currency}) => {
    const navigate = useNavigate();
    const {data, isLoading, isError, isSuccess} = useGetWalletBalance();
    const queryClient = useQueryClient();
    const onRefreshHandler = (cb) => {
      queryClient.invalidateQueries("wallet-balance");
      let millis = 0;
      const timerId = setInterval(() => {
       
        if(isSuccess || isError || millis/1000 > 30){
          cb();
         clearInterval(timerId)
        }
        millis += 500
      }, 500)
    }
    const walletBalances = data?.data || {};
    return(
        <div>
            {
                currency === "naira" ? (
                    <div className={styles[currency]}>
                        <CurrencyCard variant={currency} symbol={currency} amount={convertToCurrency(walletBalances.ngn)} 
                        onRefresh={onRefreshHandler}
                        style={{minHeight:"184px"}}/>
                        <div style={{gap:"20px", alignItems:"flex-start"}} className={`row-start ${styles.ActionCards}`}>
                            <ActionCard variant='secondary' icon={icons.swapCurrency} 
                            title="Swap Currency" onClick={() => startTransition(() =>navigate("/wallet/swap-currency")) }
                            subtitle='The App also enables users to swap between currencies'/>
                            <ActionCard variant='primary' subtitle='Deposit money into your wallet' 
                            icon={icons.addColor} title="Make Deposit"  onClick={() => startTransition(() =>navigate("deposit")) } />
                            <ActionCard variant='tertiary' icon={icons.download}
                            onClick={() => startTransition(() =>navigate("withdraw")) } 
                            title="Withdraw Money" 
                            subtitle='Withdraw money from your account'/>
                        </div>
                    </div>
                ): (
                    <div className={styles[currency]}>
                        <CurrencyCard variant={currency} symbol={currency} 
                        onRefresh={onRefreshHandler}
                        amount={currency ==="dollar" ? convertToCurrency(walletBalances.usd || 0) : convertToCurrency(walletBalances.eur || 0)} style={{minHeight:"184px"}} />
                        <ActionCard variant='secondary' icon={icons.swapCurrency} 
                        title="Swap Currency" onClick={() => startTransition(() =>navigate("/wallet/swap-currency")) }
                            subtitle='The App also enables users to swap between currencies'/>
                    </div> 
                )
            }
        </div>
    )

}

export default Banner